import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, Injector, ChangeDetectionStrategy } from '@angular/core';
import { Mtrki02Component } from './mtrki02.component';
import { Mtrki02DetailComponent } from './mtrki02-detailPkg.component';
import { JackBaseComponentModule, MaterialModule } from 'jk-service';
import { JkBillFormComponent } from 'jk-advcom';
import { jkGlb, jkLib, kmAttach, UploadFileComponent, entityState, JkTableService, } from 'jk-service';

@Component({
  selector: 'app-mtrki02-bill',
  standalone: true,
  imports: [CommonModule,
    MaterialModule,
    JackBaseComponentModule,
    Mtrki02Component,
    Mtrki02DetailComponent,
  ],
  templateUrl: './mtrki02BillPkg.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Mtrki02BillComponent extends JkBillFormComponent implements OnInit {
  override _programId = 'mtrki02'; //###
  override detailVisible: boolean = false;
  override masterPage!: Mtrki02Component;
  override detailPage!: Mtrki02DetailComponent;
  constructor() {
    super();
    this.setFormOpt2(); //###
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  override doMasterPageReady($event: any) {
    super.doMasterPageReady($event);
  }
  // 以下客製 --------------------------------------------------------
  /*
  override initCrudbar(crudbar: CrudbarNavComponent): void {
    super.initCrudbar(crudbar);
    if (crudbar) {
      // [userCaption1]="'上傳附件'" [user2Visible]="true" [userCaption2]="'發MAIL'" [user2Visible]="true" [userCaption3]="'說明'">
      crudbar.cbUser1 = this.doUploadBar.bind(this);
      crudbar.cbUser2 = this.srv.doMail.bind(this);
      crudbar.cbUser3 = this.srv.doHelp.bind(this);
    }
  }
  doUploadBar() {
    this.doUpload(this.srv.item);
  }*/
  doUpload() {
    const item = this.item; // this.masterGrid.selectedItem;
    if (!jkLib.haveValue(item)) {
      alert("請先選單號!!!");
      return;
    }
    if ((item.WB001 === '' || item.WB002 === '')) {
      alert("請先選單號!!!");
    }
    else {
      //var urlUpload = "http://www.jack168.com/upload/default.aspx"; // ?path=//nas5/Public/附件區/" + jkGlb.User.dbname() + "/YYYYMM/工作日報/W102-" + TD002;
      // DBNAME/工作日報/年月/單別-單號
      // urlUpload = urlUpload + "?path=C:/rd/附件區/" + jkGlb.User.dbname + "/" + myTable.getField("CREATE_DATE").substring(0, 6) + "/" + myTable.billType() + "-" + myTable.billNo();
      //urlUpload = urlUpload + "?path=D:/附件區/" + this.login.dbname + "/" + this.item.CREATE_DATE.substring(0, 6) + "/" + this.entityType.billType + "-" + this.entityType.billNo;
      // JkuploadComponent TODO: 測試
      let uploadHost = jkGlb.env.baseAttachUrl; //"http://rmserver.jack168.com/emonapp/upload/default.aspx";
      if (!uploadHost) {
        uploadHost = this.login.host;
      }
      let basePath = "/mnt/附件區";
      // \\jkw10-vm\data\附件區 --> /mnt/附件區
      //let uploadDirectory = `${basePath}/${this.login.dbname}/${date.substring(0, 6)}/${this.srv.entityType.billType}-${this.srv.entityType.billNo}`;
      kmAttach(this.dialog, this.login.dbname, uploadHost, basePath, item.CREATE_DATE, this.masterPage.srv.entityType.billType, item.WB002)
        .subscribe((result) => {
          if (result) {
            const files = result.rowsAffected;
            if (files) {
              if (typeof files === 'number') {
                // item.WB035 = item.WB035 + files; TODO:
              }
              ;
            }
          } //if
        });

    };
  }


}
